export default "__VITE_ASSET__BUayE_kf__"